// GLOBAL VARIABLES & CONSTANTS ---------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------- //
  
  const taggedSTOREONLY = product.tags.indexOf("STOREONLY") !== -1;
  const taggedNPISO = product.tags.indexOf("NPISO") !== -1;
  const taggedYPISO = product.tags.indexOf("YPISO") !== -1;
  const inStoreOnly = taggedSTOREONLY || taggedNPISO || taggedYPISO ? true : false;
  const showBasementeerDiscount = !(product.tags.indexOf("nodiscount") !== -1 || taggedNPISO || product.tags.indexOf("hidediscount") !== -1);
  const selectedOptions = [];
  // let selectedVariant = {{ product.selected_or_first_available_variant | json }};

  const productDeliveryMethodInput = document.querySelector('[name="properties[Delivery Method]"]');
  const doorDashZipInput = document.querySelector('[name="doordash-zip-code"]');
  const quantitySelector = document.getElementById('Quantity');


// LISTENERS ----------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------- //

  $('form#add-to-cart').on('submit', e => {
    e.preventDefault(); // Prevent the default form submission

    // Gather form data with correct Shopify format
    var formData = {
      id: product.selected_variant_id || $('#product-select').val(), // Get the selected variant ID
      quantity: parseInt($(e.target).find('[name="quantity"]').val() || 1),
      properties: {}
    };

    // Add properties if they exist
    $(e.target).find('[name^="properties["]').each(function() {
      var propName = $(this).attr('name').match(/\[(.*?)\]/)[1];
      formData.properties[propName] = $(this).val();
    });

    // Send the AJAX request
    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: JSON.stringify(formData),
      contentType: 'application/json',
      dataType: 'json',
      success: function() {
        updateCartCountDisplay();
        const button = $('#addToBagButton');
        animateAddToBagButton(button);
      },
      error: function(xhr, error) {
        console.error('There was an error adding the product to the cart.', error, xhr.status, xhr.responseText);
      }
    });
  });
  

  // prevent enter key from submitting add to bag form (fix for zip code field)
  $("form#add-to-cart").keydown((e) => {
    if(e.keyCode == 13) {
      e.preventDefault();
      // setZIP();
      return false;
    }
  });

  // listen for option selection
  var swatchInputs = document.querySelectorAll('.product-swatch > label > input');
  swatchInputs.forEach(function(element) {
    element.addEventListener('input', function(event) {
      let option = event.target.name;
      let value = event.target.value;
      selectedOptions[option] = value; // update selected options
      selectedVariant = findVariantBySelectedOptions(); // update selected variant
      updateSingleOptionSelector(option, value);
    });
  });

  $(document).ready(() => {
    selectSwatchesForCurrentOptions();
    if (product.alerts && product.alerts.length > 0) {
      product.alerts.forEach((alert, i) => {
        const alertHTML = `<div id="product-alert-${i}" class="alert ${alert.style} border-top">${ alert.text }</div>`;
        document.querySelector(alert.location).innerHTML += alertHTML;
      });
    }
  });

  quantitySelector?.addEventListener('input', (e) => {
    updateShippingCost();
  });


// FUNCTIONS >> General functions -------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------- //

  // get current selected values
  function selectSwatchesForCurrentOptions() {
    let selectedVariant = $('#product-select').val();
    let result = product.variants.find((variant) => {
      return variant.id === parseInt(selectedVariant);
    });
    if (result) {
      $(`input[name="option1"][value="${result.option1.replace(/"/g, '&quot;')}"]`).prop('checked', true);
      $(`input[name="option2"][value="${result.option2.replace(/"/g, '&quot;')}"]`).prop('checked', true);
    }
  }

  // update single option selectors
  function updateSingleOptionSelector(option, value) {
    $(`.single-option-selector[data-option=${option}]`).val(value).change();
  }

  // update available option swatches
  function updateAvailableSwatches(variant) {
    $('.product-swatch').addClass('unavailable'); // mark all swatches unavailable

    // update available option2 swatches
    let availableVariantsWithOption1 = product.variants.filter(function(v) { return v.option1 === variant.option1 && v.available; });
    let availableOption2Values = availableVariantsWithOption1.map(function(v) { return v.option2.toString(); });
    $('.product-swatch[data-option="option2"]').each(function() {
      let value = $(this).attr('data-value').toString();
      if(availableOption2Values.includes(value)) $(this).removeClass('unavailable');
    });

    // update available option1 swatches
    let availableVariantsWithOption2 = product.variants.filter(function(v) { return v.option2 === variant.option2 && v.available; });
    let availableOption1Values = availableVariantsWithOption2.map(function(v) { return v.option1.toString(); });
    $('.product-swatch[data-option="option1"]').each(function() {
      let value = $(this).attr('data-value').toString();
      if(availableOption1Values.includes(value)) $(this).removeClass('unavailable');
    });
  }

  // find selected variant
  function findVariantBySelectedOptions() {
    if(!selectedOptions.option1 || !selectedOptions.option2) return null;
    let result = product.variants.find((variant) => {
      return variant.option1 === selectedOptions.option1 && variant.option2 === selectedOptions.option2;
    });
    return result;
  }
  
  // update pricing
  function updatePricing(variant) {
    if(variant.price <= (variant.compare_at_price * 0.95)) $('#product-price').addClass('on-sale');
    if(variant.price > (variant.compare_at_price * 0.95)) $('#product-price').removeClass('on-sale');
    let productPriceContainers = document.querySelectorAll('.product-price');
    productPriceContainers.forEach(function(e) { e.innerText = Shopify.formatMoney(variant.price); });
    let productCompareAtPriceContainers = document.querySelectorAll('.product-compare-price');
    productCompareAtPriceContainers.forEach(function(e) { e.innerText = Shopify.formatMoney(variant.compare_at_price); });
  }

  // update savings
  function updateSavings(variant) {
    if(taggedNPISO) return
    let savings = Math.round(((variant.compare_at_price - variant.price) / variant.compare_at_price) * 100);
    let productSavingsContainer = document.getElementById('product-savings');
    let productSavingsBasementeerContainer = document.getElementById('product-savings-basementeer');
    let productSavingsWrapper = document.getElementById('product-savings--wrapper');
    let savingsText = savings >= 5 ? `${savings}% off` : null;
    // let basementeerText = ((savings > 0 && savings < 5) || !showBasementeerDiscount) ? null : savings === 0 ? `Basementeers save ${savingsBasementeer}%` : `Basementeers get ${savingsBasementeer}% off`;
    let basementeerText = !showBasementeerDiscount ? null : savings < 10 ? `Basementeers always save 10%` : `+ Basementeers save an extra 10%`;
    if(productSavingsContainer) productSavingsContainer.innerText = savingsText;
    if(productSavingsBasementeerContainer) {
      productSavingsBasementeerContainer.innerText = basementeerText;
      savings < 10 ? productSavingsBasementeerContainer.classList.add('text-sb-green') : productSavingsBasementeerContainer.classList.remove('text-sb-green');
    }
    if (!savingsText || !basementeerText) productSavingsBasementeerContainer.classList.remove('border-l', 'border-sb-grey-400', 'pl-2');
    basementeerText ? productSavingsBasementeerContainer.classList.remove('hidden') : productSavingsBasementeerContainer.classList.add('hidden');
    if(savings >= 5) productSavingsWrapper.classList.add('on-sale');
    if(savings < 5) productSavingsWrapper.classList.remove('on-sale');
  }

  // update main image
  function updateProductImage(variant) {
    if (variant.featured_image) {
      var newImage = variant.featured_image; // New image object.
      var mainImageDomEl = jQuery('#product-image')[0]; // DOM element of main image we need to swap.
      Shopify.Image.switchImage(newImage, mainImageDomEl, switchImage); // Define switchImage (the callback) in your theme's JavaScript file.
    }
  }

  // update deal flag
  function updateDealFlag(variant) {
    let savings = Math.round(((variant.compare_at_price - variant.price) / variant.compare_at_price) * 100);
    $('.product-flags .savings').remove();
    if(savings < 5) return;
    $('.product-flags').prepend('<div class="product-flag savings"></div>');
  }

  // update add to bag button
  function updateAddToBagButton(variant, deliveryMethodSelected) {
    let deliveryMethodElement = document.querySelector('input[name="properties[Delivery Method]"]');
    let addToCartText = !variant.available ? 'SOLD OUT' : product.tags.includes('PREORDER') || variant.preorder.on_preorder ? 'PREORDER' : 'ADD TO BAG'; // set add to bag text
    if (addToBagButton) {
      addToBagButton.disabled = !deliveryMethodElement ? false : deliveryMethodElement.value && variant.available ? false : true;
      addToBagButton.setAttribute("aria-disabled", !deliveryMethodElement ? "false" : deliveryMethodElement.value && variant.available ? "false" : "true");
      addToBagButton.innerText = addToCartText;
    }
  }

  // update article number
  function updateArticleNumber(variant) {
    const articleNumberContainer = document.getElementById("article-number");
    if (!articleNumberContainer) return;
    articleNumberContainer.innerText = `Article #${variant.barcode}` || '';
  }

  // update option labels
  function updateOptionLabels(variant) {
    variant.options.forEach(function(e,i) {
      $(`#option${i + 1}-label`).text(e);
    });
  }

  async function updateShippingCost(variant) {
    variant = variant || product.variants.find(v => v.barcode == document.getElementById("article-number").innerText.replace('Article #', '').trim());
    const cartData = await getCart();
    const quantity = quantitySelector.value;
    const pickupCost = variant.price * quantity >= 3000 || cartData.total_price >= 3000 || (variant.price * quantity) + cartData.total_price >= 3000 ? '<div class="text-right">FREE</div>' : '<div class="py-2.5">FREE</div>';
    const shippingCost = product.tags.includes('SHIPBIKE') ? '<div class="text-right">$100</div>' : variant.price * quantity >= 3000 || cartData.total_price >= 3000 || (variant.price * quantity) + cartData.total_price >= 3000 ? '<div class="text-right">FREE</div>' : '<div>FREE</div><div class="text-sm font-normal">For orders $30+</div>';
    const doorDashCost = variant.price * quantity >= 3000 || cartData.total_price >= 3000 || (variant.price * quantity) + cartData.total_price >= 3000 ? '<div class="text-right">FREE</div>' : '<div>FREE</div><div class="text-sm font-normal">For orders $30+</div>';
    const pickupCostContainer = document.querySelector('.delivery-method-tile[data-method="pickup"] .delivery-method-tile--cost');
    const shippingCostContainer = document.querySelector('.delivery-method-tile[data-method="ship"] .delivery-method-tile--cost');
    const doorDashCostContainer = document.querySelector('.delivery-method-tile[data-method="doordash"] .delivery-method-tile--cost');
    pickupCostContainer ? pickupCostContainer.innerHTML = pickupCost : null;
    shippingCostContainer ? shippingCostContainer.innerHTML = shippingCost : null;
    doorDashCostContainer ? doorDashCostContainer.innerHTML = doorDashCost : null;
  }

  function updatePreorderAlert(variant) {
    if (!variant) return;
    const affirmText = document.querySelector('p.affirm-as-low-as');
    const alertContainer = document.getElementById('alert-loc-pricing');
    if (!alertContainer) {
      if (affirmText) affirmText.classList.remove('hidden');
      return;
    }

    if (alertContainer.querySelector('div.cross-merch-alert')) return;

    alertContainer.querySelectorAll('.preorder-alert').forEach(el => el.remove());
    if (!variant.preorder.on_preorder) {
      if (affirmText) affirmText.classList.remove('hidden');
      return;
    }

    if (affirmText) affirmText.classList.add('hidden');
    const preorderAlert = document.createElement('div');
    preorderAlert.classList = 'preorder-alert font-bold italic text-sm text-sb-blue mb-4';
    preorderAlert.innerText = variant.preorder.on_preorder ? variant.preorder.text : '';
    alertContainer.prepend(preorderAlert);
    return true;
  }

  function updatePreorderFlag(variant) {
    if (!variant) return;
    const productFlagContainers = document.querySelectorAll('.product-flags');
    productFlagContainers.forEach(container => {
      container.querySelectorAll('.product-flag.preorder').forEach(flag => flag.remove());
      if (variant.preorder.on_preorder) {
        const preorderFlag = document.createElement('div');
        preorderFlag.classList = 'product-flag h6 preorder';
        preorderFlag.innerText = 'PREORDER';
        container.appendChild(preorderFlag);
      }
    });
    return true;
  }

  function updatePreorderDeliveryMethods(variant) {
    if (!variant) return;
    const doordashDeliveryMethodTile = document.querySelector('.delivery-method-tile[data-method="doordash"]');
    const productDeliveryMethodInput = document.querySelector('[name="properties[Delivery Method]"]');
    if (!doordashDeliveryMethodTile) return;
    if (variant.preorder?.on_preorder) {
      doordashDeliveryMethodTile.classList.add('hidden');
      if (productDeliveryMethodInput.value.includes('DoorDash')) {
        setDeliveryMethodValue(doordashDeliveryMethodTile.closest(".delivery-method-tiles--wrapper"));
      }
    } else {
      doordashDeliveryMethodTile.classList.remove('hidden');
      if (productDeliveryMethodInput && !productDeliveryMethodInput.value) autofillUserPreferences(); // if deliviery method not selected, autofill delivery preferences
    }
  }


  async function selectCallback(variant, selector) {
    if (!variant || document.readyState === "loading") return;

    product.selected_variant_id = variant.id;
    
    const deliveryMethodTilesGroup = document.querySelector('.delivery-method-tiles--wrapper') || null;

    if (deliveryMethodTilesGroup && document.querySelector('.delivery-method-tile[data-method="pickup"]') && document.querySelector('.delivery-method-tile[data-method="pickup"] .delivery-method-tile--secondary').classList.contains('open') || productDeliveryMethodInput && productDeliveryMethodInput.value.includes('Pickup')) {
      updateStoresAvailability(variant.barcode);
    }

    // recheck doordash availability
    if (doorDashZipInput?.value.length) handleDeliveryZipcodeInput(doorDashZipInput);

    updatePreorderFlag(variant);
    updatePreorderAlert(variant);
    updatePreorderDeliveryMethods(variant);
    updatePricing(variant);
    updateShippingCost(variant);
    // updateAvailableSwatches(variant);
    updateSavings(variant);
    updateDealFlag(variant);
    updateProductImage(variant);
    updateArticleNumber(variant);
    updateOptionLabels(variant);
    $('[name="secondary-selector--sameday-zip"]').trigger('input');

    // update variant details (e.g., nutrition facts)
    $(".variant-details").hide();
    $("#variant-details-" + variant.id).show();
          
    // update gift card design property
    if ($("#cardDesignProperty").length) $("#cardDesignProperty").val(variant.featured_image.src);
    
    // update magic sign link
    let url = new URL(window.location.href);
    let url_params = url.searchParams;
    url_params.set("view","magic-sign");
    url_params.set("variant", variant.id);
    url.search = url_params.toString();
    let ms_url = url.toString();
    $("#magic-sign-link").attr("href", ms_url);

    updateAddToBagButton(variant);
  }

  // // split option selectors
  $(($) => new Shopify.OptionSelectors('product-select', { product: product, onVariantSelected: selectCallback, enableHistoryState: true }));